// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2757":"395124961726bb8a","7831":"ec75f96e9a242d45"}[chunkId] + ".css";
};